import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import notificationsServices from '@src/services/notifications.service';

export const getPendingNotifications = createAsyncThunk(
  'getPendingNotifications',
  async ({ vouId = 1 }, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const customerId = state?.customer?.selectedCustomer?.customerId;
      const menus = state?.menus?.menus || [];
      const getAuthorizedVouIds = () => {
        const vouIdSet = new Set();

        const collectVouIds = (items) => {
          if (!Array.isArray(items)) return;

          items.forEach((item) => {
            if (item?.vouId) {
              vouIdSet.add(Number(item.vouId));
            }
            if (Array.isArray(item?.userSubMenus)) {
              collectVouIds(item.userSubMenus);
            }
          });
        };

        collectVouIds(menus);
        return Array.from(vouIdSet).filter(Boolean);
      };

      const authorizedVouIds = getAuthorizedVouIds();
      const hasVouPermission = (id) => authorizedVouIds.includes(Number(id));

      if (!customerId && !vouId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      if (vouId === 4) {
        if (!hasVouPermission(4)) {
          return { data: { items: [] } };
        }

        return await notificationsServices.getPendingNotifications({
          id: 'getPendingNotifications',
          customerId: customerId,
          vouId: vouId,
          page: 1,
          pageSize: 99,
        });
      } else {
        const requestedVouIds = [...new Set([Number(vouId), 4, 11, 94])].filter((id) =>
          hasVouPermission(id),
        );
        if (!requestedVouIds.length) {
          return { data: { items: [] } };
        }

        const responses = await Promise.all(
          requestedVouIds.map((id) =>
            notificationsServices.getPendingNotifications({
              id: 'getPendingNotifications',
              customerId: customerId,
              vouId: id,
              page: 1,
              pageSize: 99,
            }),
          ),
        );

        const preferredIndex = requestedVouIds.indexOf(Number(vouId));
        const baseResponse =
          (preferredIndex > -1 ? responses[preferredIndex] : responses[0]) || { data: { items: [] } };

        baseResponse.data = baseResponse.data || {};
        baseResponse.data.items = responses.flatMap((response) => response?.data?.items || []);
        return baseResponse;
      }
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  notificationList: [],
  // Set when the language is switched away from the pages that render the list: the already
  // loaded notification texts come from the backend and are therefore in the previous language.
  // The bell popover re-fetches them on open instead of every page firing the request on every
  // language switch.
  isStale: false,
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    markNotificationsStale: (state) => {
      if (state.notificationList?.length) {
        state.isStale = true;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPendingNotifications.fulfilled, (state, action) => {
      state.notificationList = action?.payload?.data?.items || [];
      state.isStale = false;
    });
    builder.addCase(getPendingNotifications.rejected, (state) => {
      state.notificationList = initialState.notificationList;
      state.isStale = false;
    });
  },
});

export const { markNotificationsStale } = notificationsSlice.actions;
